/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/


export default {
  ADD_PURCHASE(state, i) {
    state.purchases.unshift(i)
  },
  SET_PURCHASES(state, i) {
    state.purchases = i
  },
  UPDATE_PURCHASE(state, i) {
      const index = state.purchases.findIndex((m) => m.id == i.id)
      Object.assign(state.purchases[index], i)
  },
  REMOVE_PURCHASE(state, i) {
      const index = state.purchases.findIndex((j) => j.id == i)
      state.purchases.splice(index, 1)
  },

}
